module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-ix"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/maps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/tables"
    }
  }, [_vm._v("List of Tables")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/guide"
    }
  }, [_vm._v("Hungarian Pronunciation Guide")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "tn"
  }, [_vm._v("1")]), _vm._v(" A Brief History of Hungary up to the End of the Second World War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_vm._v("The Magyar People")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Bitter Awakening")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_vm._v("Defence Attempts")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Resurrection")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec5"
    }
  }, [_vm._v("The End of Concealment")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec6"
    }
  }, [_vm._v("Opening Up")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec7"
    }
  }, [_vm._v("Arming the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec8"
    }
  }, [_vm._v("The First Military Conflict")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec9"
    }
  }, [_vm._v("On the Road to the Second World War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec10"
    }
  }, [_vm._v("Attack Towards the South")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec11"
    }
  }, [_vm._v("Joining the Attack on the Soviet Union")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_1#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hungarians at the Don River")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_1#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shift in Policy")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_1#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The German Occupation of Hungary")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_1#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Waffen-SS and Hungary")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_1#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horthy’s Failed Coup")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_12#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Arrow Cross Regime")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_12#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Siege of ‘Fortress Budapest’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_12#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Months of the War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01_12#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peace and the Aftermath")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-x"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tn"
  }, [_vm._v("2")]), _vm._v(" Organization and Equipment of the Royal Hungarian Army Before and During the Second World War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shifting Focus from Quantity to Quality")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mobilization")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Officers of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Honvédség")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Staff Corps")])]), _vm._v(" "), _c('h4', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Engineer Staff Corps")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chain of Command")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hungary’s Participation in the Second World War")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Anti-Soviet Campaign")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Huba II Plan")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Huba III Plan")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Szabolcs Plan")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preparation for the Defence of Hungary")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("‘Fall Margarethe I.’ (Case Margaret I)")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Szabolcs II Plan")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Replacement Army")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Germany Takes Over")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Battle for ‘Fortress Budapest’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02_1#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Days")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tn"
  }, [_vm._v("3")]), _vm._v(" Hungarian Army Armoured Formations and their Equipment")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Csaba Armoured Car")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toldi Light Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nimród Self-propelled Tank Destroyer and Anti-aircraft Gun")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turán Medium Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turán I Medium Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turán II Heavy Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turán III Heavy Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vezér")]), _vm._v(" Turán Command Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zrínyi II Assault Howitzer")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zrínyi I Assault Gun")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tas Heavy Tank")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Armour in Action")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a03f5252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 75
// module chunks = 0